import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { ICatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder.entity";
import { getMenuFeatureMapping } from "../apiCall";
import { MenuKeys } from "../entity";

export const MenuFeaturesMapping = (props: any) => {
  const { request } = props;

  const columns: ICatalogBuilder['pagingColumns'] = [
    {
      field: "DisplayName",
      headerName: "Display Name",
      editable: false,
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    // {
    //   field: "ModuleName",
    //   headerName: "Module Name",
    //   editable: false,
    //   flex: 1,
    //   minWidth: 130,
    //   headerAlign: "left",
    // }
  ];

  return (
    <CatalogBuilder
      isHeader={false}
      isPlusButton={false}
      isAssociationButton={true}
      isDefaultActionButton={false}

      getPagingData={getMenuFeatureMapping}
      pagingAPIrequest={request}
      pagingAPIKey={MenuKeys.getFeatures}

      // onDelete={deleteMenuFeaturesMapping} 
      // deletePagingAPIKey={MenuKeys.deleteFeatures} 

      pagingColumns={columns}
    />

  );
}   